export default __webpack_public_path__ + "static/media/dpmain.c0a8668e.jpg";